
import styled from "styled-components"

export const InputStyle = styled.input`
  background: #ffffff;
  border: 0.619965px solid #adbfcf;
  border-radius: 7.43958px;
  width: 100%;
  height: 45px;
  box-sizing: border-box;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 18.5718px;
  line-height: 25px;
  color: #1c3935;
  padding-left: 10px;
`;
export const SearchInputWrapper = styled.div`
 width: 555.36px;
  height: 53.54px;
  background: #ffffff;
  border: 1px solid #1AA5C0;
  border-radius: 8.7557px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  input {
    all: unset;
    width: 90%;
    border-style: none;
    height: 80%;
    font-size: 22px;
    padding: 10px;
  }
  
`;